import { render, staticRenderFns } from "./LocationModal.vue?vue&type=template&id=a84a4efc&scoped=true"
import script from "./LocationModal.vue?vue&type=script&lang=ts"
export * from "./LocationModal.vue?vue&type=script&lang=ts"
import style0 from "./LocationModal.vue?vue&type=style&index=0&id=a84a4efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84a4efc",
  null
  
)

export default component.exports